/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import DashboardsurgeriesReadinessRisk from './DashboardsurgeriesReadinessRisk';

/**
 * The InlineResponse200 model module.
 * @module model/InlineResponse200
 * @version v0.3
 */
export default class InlineResponse200 {
  /**
   * Constructs a new <code>InlineResponse200</code>.
   * @alias module:model/InlineResponse200
   * @class
   * @param id {String}
   * @param timeBucket {String}
   * @param tasksOverdueCount {Number}
   * @param tasksTotalCount {Number}
   * @param clearanceGoalsCompleted {Number}
   * @param clearanceGoalsTotal {Number}
   * @param readiness {module:model/InlineResponse200.ReadinessEnum}
   * @param readinessRisk {module:model/DashboardsurgeriesReadinessRisk}
   */
  constructor(id, timeBucket, tasksOverdueCount, tasksTotalCount, clearanceGoalsCompleted, clearanceGoalsTotal, readiness, readinessRisk) {
    this.id = id;
    this.timeBucket = timeBucket;
    this.tasksOverdueCount = tasksOverdueCount;
    this.tasksTotalCount = tasksTotalCount;
    this.clearanceGoalsCompleted = clearanceGoalsCompleted;
    this.clearanceGoalsTotal = clearanceGoalsTotal;
    this.readiness = readiness;
    this.readinessRisk = readinessRisk;
  }

  /**
   * Constructs a <code>InlineResponse200</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/InlineResponse200} obj Optional instance to populate.
   * @return {module:model/InlineResponse200} The populated <code>InlineResponse200</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new InlineResponse200();
      if (data.hasOwnProperty('id'))
        obj.id = ApiClient.convertToType(data['id'], 'String');
      if (data.hasOwnProperty('first_name'))
        obj.firstName = ApiClient.convertToType(data['first_name'], 'String');
      if (data.hasOwnProperty('last_name'))
        obj.lastName = ApiClient.convertToType(data['last_name'], 'String');
      if (data.hasOwnProperty('surgery_date'))
        obj.surgeryDate = ApiClient.convertToType(data['surgery_date'], 'Date');
      if (data.hasOwnProperty('surgery_type'))
        obj.surgeryType = ApiClient.convertToType(data['surgery_type'], 'String');
      if (data.hasOwnProperty('surgery_status'))
        obj.surgeryStatus = ApiClient.convertToType(data['surgery_status'], 'String');
      if (data.hasOwnProperty('patient_status'))
        obj.patientStatus = ApiClient.convertToType(data['patient_status'], 'String');
      if (data.hasOwnProperty('surgeon'))
        obj.surgeon = ApiClient.convertToType(data['surgeon'], 'String');
      if (data.hasOwnProperty('time_bucket'))
        obj.timeBucket = ApiClient.convertToType(data['time_bucket'], 'String');
      if (data.hasOwnProperty('tasks_overdue_count'))
        obj.tasksOverdueCount = ApiClient.convertToType(data['tasks_overdue_count'], 'Number');
      if (data.hasOwnProperty('tasks_total_count'))
        obj.tasksTotalCount = ApiClient.convertToType(data['tasks_total_count'], 'Number');
      if (data.hasOwnProperty('clearance_goals_completed'))
        obj.clearanceGoalsCompleted = ApiClient.convertToType(data['clearance_goals_completed'], 'Number');
      if (data.hasOwnProperty('clearance_goals_total'))
        obj.clearanceGoalsTotal = ApiClient.convertToType(data['clearance_goals_total'], 'Number');
      if (data.hasOwnProperty('readiness'))
        obj.readiness = ApiClient.convertToType(data['readiness'], 'String');
      if (data.hasOwnProperty('readiness_risk'))
        obj.readinessRisk = DashboardsurgeriesReadinessRisk.constructFromObject(data['readiness_risk']);
      if (data.hasOwnProperty('comorbidities'))
        obj.comorbidities = ApiClient.convertToType(data['comorbidities'], ['String']);
    }
    return obj;
  }
}

/**
 * @member {String} id
 */
InlineResponse200.prototype.id = undefined;

/**
 * @member {String} firstName
 */
InlineResponse200.prototype.firstName = undefined;

/**
 * @member {String} lastName
 */
InlineResponse200.prototype.lastName = undefined;

/**
 * @member {Date} surgeryDate
 */
InlineResponse200.prototype.surgeryDate = undefined;

/**
 * @member {String} surgeryType
 */
InlineResponse200.prototype.surgeryType = undefined;

/**
 * @member {String} surgeryStatus
 */
InlineResponse200.prototype.surgeryStatus = undefined;

/**
 * @member {String} patientStatus
 */
InlineResponse200.prototype.patientStatus = undefined;

/**
 * @member {String} surgeon
 */
InlineResponse200.prototype.surgeon = undefined;

/**
 * @member {String} timeBucket
 */
InlineResponse200.prototype.timeBucket = undefined;

/**
 * @member {Number} tasksOverdueCount
 */
InlineResponse200.prototype.tasksOverdueCount = undefined;

/**
 * @member {Number} tasksTotalCount
 */
InlineResponse200.prototype.tasksTotalCount = undefined;

/**
 * @member {Number} clearanceGoalsCompleted
 */
InlineResponse200.prototype.clearanceGoalsCompleted = undefined;

/**
 * @member {Number} clearanceGoalsTotal
 */
InlineResponse200.prototype.clearanceGoalsTotal = undefined;

/**
 * Allowed values for the <code>readiness</code> property.
 * @enum {String}
 * @readonly
 */
InlineResponse200.ReadinessEnum = {
  /**
   * value: "low"
   * @const
   */
  low: "low",

  /**
   * value: "medium"
   * @const
   */
  medium: "medium",

  /**
   * value: "high"
   * @const
   */
  high: "high",

  /**
   * value: "no_surgery_date"
   * @const
   */
  noSurgeryDate: "no_surgery_date",

  /**
   * value: "surgery_past"
   * @const
   */
  surgeryPast: "surgery_past"
};
/**
 * @member {module:model/InlineResponse200.ReadinessEnum} readiness
 */
InlineResponse200.prototype.readiness = undefined;

/**
 * @member {module:model/DashboardsurgeriesReadinessRisk} readinessRisk
 */
InlineResponse200.prototype.readinessRisk = undefined;

/**
 * @member {Array.<String>} comorbidities
 */
InlineResponse200.prototype.comorbidities = undefined;
